import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'h漫画',
            url: 'https://hmanga.com',
            description: 'h漫画是专为成熟读者打造的在线漫画阅读平台，汇聚海量h漫画资源，涵盖日系、国产、韩漫等多种风格。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://hmanga.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: 'h漫画网站是否免费？', acceptedAnswer: { '@type': 'Answer', text: 'h漫画平台提供大量免费漫画内容供读者阅读。部分VIP章节可能需要订阅，但我们会持续提供丰富的免费内容。' } },
              { '@type': 'Question', name: '支持哪些设备阅读？', acceptedAnswer: { '@type': 'Answer', text: 'h漫画支持PC端、平板和手机端阅读，采用响应式设计，自动适配不同屏幕尺寸。' } },
              { '@type': 'Question', name: '漫画更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '编辑团队每日更新漫画内容，热门连载作品保证周更，部分爆款作品甚至日更。' } },
              { '@type': 'Question', name: '如何找到想看的漫画？', acceptedAnswer: { '@type': 'Answer', text: '通过首页分类导航进入不同风格的漫画专区，也可以在搜索功能中通过作品名或作者名查找。' } },
              { '@type': 'Question', name: '漫画内容是否正版授权？', acceptedAnswer: { '@type': 'Answer', text: 'h漫画始终坚持正版理念，所有上线作品均已获得版权方授权。' } },
              { '@type': 'Question', name: '如何联系客服？', acceptedAnswer: { '@type': 'Answer', text: '通过关于我们页面的联系方式与我们取得联系，包括邮箱和客服QQ等渠道。' } },
            ],
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommend />
          <CategoryNav />
          <LatestUpdates />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}